<script setup lang="ts">
import FooterLinksItem from '@/components/Footer/footer-links/FooterLinksItem.vue'

const FooterDownloadButton = defineAsyncComponent(
  () => import('@/components/Footer/FooterDownloadButton.vue'),
)
const FooterLinksForClients = defineAsyncComponent(
  () => import('@/components/Footer/footer-links/FooterLinksClients.vue'),
)
const FooterLinkSupport = defineAsyncComponent(
  () => import('@/components/Footer/footer-links/FooterLinksSupport.vue'),
)
const FooterLinkCompany = defineAsyncComponent(
  () => import('@/components/Footer/footer-links/FooterLinksCompany.vue'),
)
const FooterLinksInformation = defineAsyncComponent(
  () => import('@/components/Footer/footer-links/FooterLinksInformation.vue'),
)
const FooterLinksApp = defineAsyncComponent(
  () => import('@/components/Footer/footer-links/FooterLinksApp.vue'),
)

const { isDesktop } = useResponsive()
</script>

<template>
  <section class="footer-links">
    <footer-download-button v-if="!isDesktop" />

    <footer-links-item title="Клиентам">
      <footer-links-for-clients />
    </footer-links-item>

    <footer-links-item title="Поддержка">
      <footer-link-support />
    </footer-links-item>

    <footer-links-item title="Компания">
      <footer-link-company />
    </footer-links-item>

    <footer-links-item title="Информация">
      <footer-links-information />
    </footer-links-item>

    <footer-links-item v-if="isDesktop" title="Наше приложение">
      <footer-links-app />
    </footer-links-item>
  </section>
</template>

<style lang="scss" scoped>
.footer-links {
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
  justify-content: space-between;
  width: 100%;
  padding: 40px 0;
  border-bottom: 1px solid #d8dee9;

  @include media('>desktop-mini') {
    grid-template-columns: 170px 170px 270px 270px 170px;
    gap: 36px;
  }
}
</style>
